import { Subscription, Subject, takeUntil, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { HhsgSharedUserProfile } from '../../../models';
import { HhsgSharedNotificationModel } from '../../../models/notification.model';
import { HhsgSharedNotificationService } from '../../../services/notification-service';
import { HhsgSharedClient } from '../../../models/client.model';
import { Router } from "@angular/router";
import { HhsgSharedClientAdminService, HhsgSharedConfigService, HhsgSharedFormStateService, HhsgSharedLoadingService, HhsgSharedUserService } from '../../../services';
import { HhsgSharedAdminBaseComponent } from '../../common/base.component';
import { User } from '../../../models/user.model';
import { HhsgSharedApplication } from '../../../models/application.model';
import { Constants } from '../../../utilities/constants.util';
import DataSource from 'devextreme/data/data_source';

@Component({
	selector: 'hhsg-notification-admin',
	templateUrl: 'add-notification.component.html',
	styleUrls: ['add-notification.component.scss']
})

export class HhsgSharedAddNotificationComponent extends HhsgSharedAdminBaseComponent implements OnInit, OnDestroy {
	formGroup:UntypedFormGroup;
	searchModeOption: string = Constants.NotificationContains;
	searchExprOption: string = Constants.NotificationName;
	searchTimeoutOption: number = 200;
	minSearchLengthOption: number = 0;
	showDataBeforeSearchOption = false;
	selectedDropEmailsArray: string[];
	confirmSaving: boolean;
	errorMessages: string[];
	isDisabled:boolean = false;
	notification = new HhsgSharedNotificationModel();
	isFormValid: boolean = false;
	public isSubmitted: boolean = false;
	isSaveSuccessful: boolean;
	private _unsubscribe$ = new Subject<void>();
	user: HhsgSharedUserProfile;
	emails: User[];
	clients: HhsgSharedClient[];
	private _formChangesSubscription: Subscription;
	allActiveApplications: HhsgSharedApplication[] = [];
	applicationAbbreviation : string;
	selectedClientId:number;
	showErrorMessage: boolean;
	showEmailErrorMessage: boolean = false;
	showMessageBoxError: boolean;
	isDisableSave:boolean;
	isRecipientCheckedChanged: boolean = false;
	isEmailFieldRequired : boolean = true;
	isRecipientFieldRequired : boolean = true;
	isMessageFieldRequired : boolean = true;
	clientsDataSource: DataSource<any, any>;
	@ViewChild('searchableMultiSelectbox', { static: false }) searchableMultiSelectbox: any;
	emailsDataSource: any;
	searchTerm$ = new Subject<any>();

	constructor(
		private _configService: HhsgSharedConfigService,
		public _notificationService: HhsgSharedNotificationService,
		private _formBuilder:UntypedFormBuilder,
		private _ChangeDetectorRef: ChangeDetectorRef,
		private _userService: HhsgSharedUserService,
		private _formStateService: HhsgSharedFormStateService,
		private _ClientService: HhsgSharedClientAdminService,
		private _loadingService: HhsgSharedLoadingService,
		public  _router:Router) {
			super(_formStateService,_router);
			this.applicationAbbreviation = _configService.appSettings.applicationAbbreviation;

			let searchValue: string = '';
			this.searchTerm$.pipe(
				debounceTime(500),
				distinctUntilChanged(),
				switchMap(newValue => {
					searchValue = newValue;
				  return this._ClientService
				  .getAllUsersByClientId(this.selectedClientId, this.applicationAbbreviation, searchValue)
				})
			  ).subscribe((result) => {
				this.emails = [...this.emails, ...result];
				this.emails = Array.from(new Set(this.emails.map(obj => obj.id))).map(id => {
					return this.emails.find(obj => obj.id === id);
				});
				this.emailsDataSource = this.getDataSource(this.emails);
				this.openAndCloseDropdownInstance(this.searchableMultiSelectbox?.multiSelectTagBox?.instance);
				this._loadingService.setLoading(false);
			  },
				(error) => {
					this.errorMessages = error.error;
					this._loadingService.setLoading(false);
				});
		}

	async ngOnInit(): Promise<void> {
		this._userService.getUserProfile()
		.pipe(takeUntil(this._unsubscribe$))
		.subscribe(async (userProfile: HhsgSharedUserProfile) => {
			this.user = userProfile;
		});
	 this.formGroup = this._formBuilder.group({
		to:this._formBuilder.group({
			receiver:[Constants.NotificationAllUser],
			receiverClient:['',Validators.required],
			emailCheckBox:[''],
			receiverEmail:['',Validators.required]
		}),
		title:['',[Validators.required,Validators.maxLength(100)]],
		message:this._formBuilder.group({
			templateType:[Constants.NotificationCustomize],
			highPriority:[''],
			messageBox:['',Validators.required]
		})
	 })
	if(this.formGroup.get(Constants.NotificationToReceiver).value === Constants.NotificationAllUser)
	 {
		this.formGroup.get(Constants.NotificationToReceiverClient).disable();
		this.formGroup.get(Constants.NotificationToEmailCheckBox).disable();
		this.formGroup.get(Constants.NotificationToReceiverEmail).disable();
		if(this.formGroup.get(Constants.NotificationMessageMessagebox).value != null || this.formGroup.get(Constants.NotificationMessageMessagebox).value != "")
		{
				this.showMessageBoxError = true;
		}
	 }

	this.getClients();
	this.allActiveApplications = await this._ClientService.getAllActiveApplications();
	this._formChangesSubscription = this.formGroup.valueChanges.subscribe(val => {
		this._formStateService.isFormDirty = this.formGroup.dirty;
		this.validatForm();
	});

	}

ngAfterViewInit(): void {
	this._ChangeDetectorRef.detectChanges();
  }

  ngAfterContentChecked(){
	this._ChangeDetectorRef.detectChanges();
  }

	onSubmit() {
		this._loadingService.setLoading(true);
		if(this.formGroup.valid){
			this._notificationService.confirmSaving = true;
			this.isFormValid = true
		}
		this._loadingService.setLoading(false);
 	}

	 async onConfirmSaving() {
		await this.saveNotification();
	}

	async saveNotification() {
		this._loadingService.setLoading(true);
		this.assignNotificationmodel();
		var upsertData = null;
		upsertData = this.notification;
		this._notificationService.confirmSaving = false;
		await this._notificationService.SaveNotification(upsertData).then(async (result) => {
			if (result) {
				this._loadingService.setLoading(false);
				this.formGroup.reset();
				this.navigateSuccess();
			}
		},
			(error) => {
				this._notificationService.confirmSaving = false;
				this.errorMessages.push(`Unable to save Notification with name '${this.notification.name}'.`);
				this._loadingService.setLoading(false);
			});
	}

	assignNotificationmodel():void{
		let toReceiver = this.formGroup.get(Constants.NotificationToReceiver);
		let toEmailCheckBox = this.formGroup.get(Constants.NotificationToEmailCheckBox);
		let toReceiverClient = this.formGroup.get(Constants.NotificationToReceiverClient);
		let toReceiverEmail = this.formGroup.get(Constants.NotificationToReceiverEmail);
		let messageMessagebox = this.formGroup.get(Constants.NotificationMessageMessagebox);
		let messageHighPriority = this.formGroup.get(Constants.NotificationMessageHighPriority);

		this.notification.name = this.formGroup.get(Constants.NotificationTitle).value?.trim();
		this.notification.applicationId = this.allActiveApplications.filter(app => app.abbreviation == this.applicationAbbreviation)[0].id;

		if(toReceiver.value == Constants.NotificationAllUser)
		{
			this.notification.notificationType = NotificationType.AllUsers;
		}
		if(toReceiver.value == Constants.NotificationClient && toEmailCheckBox.value == "" && toReceiverClient.value != "")
		{
			this.notification.notificationType = NotificationType.Client;
			this.notification.clientId = this.formGroup.get(Constants.NotificationToReceiverClient).value;
		}
		if(toReceiver.value == Constants.NotificationClient && toReceiverClient.value != ""
				&& toEmailCheckBox.value == true && toReceiverEmail.value !="")
		{
			let emailusers = toReceiverEmail.value;
			let previousValues = emailusers.previousValue;
			let currentValues = emailusers.value;

			this.notification.notificationType = NotificationType.Email;
			/* Based on values length assigning the value of the controls to the model */
			if(currentValues.length > 10 && previousValues.length > 0){
				this.notification.emailUserIds = previousValues;
			}
			else{
				this.notification.emailUserIds = currentValues;
			}
		}
		if(messageMessagebox.value !=""){
			let richTextBoxValue = messageMessagebox.value;
			let currentRichTextBoxValue = richTextBoxValue.value;
			let previousRichTextBoxValue  = richTextBoxValue.previousValue;
			//this logic for trim value to 1000 charactors.
			if(currentRichTextBoxValue > 1000){
				this.notification.message = previousRichTextBoxValue;
			}
			else{
				this.notification.message = currentRichTextBoxValue;
			}
		}
		this.notification.isHighPriority = messageHighPriority.value;
		this.notification.UserId = this.user.userId;
	}

	navigateSuccess() {
		this._router.navigate(['/', 'notifications'], { queryParams: { showSuccess: 'true' } });
	}

	onRadioChanged(event){
		let toReceiverClient = this.formGroup.get(Constants.NotificationToReceiverClient);
		let toEmailCheckBox = this.formGroup.get(Constants.NotificationToEmailCheckBox);
		let toReceiverEmail = this.formGroup.get(Constants.NotificationToReceiverEmail);
		/* Comparing values to enable and disable the controls */
		if(event.target.value == Constants.NotificationClient){
			toReceiverClient.enable();
			this.showErrorMessage = true;
			if(this.formGroup.get(Constants.NotificationMessageMessagebox).value != null || this.formGroup.get(Constants.NotificationMessageMessagebox).value != "")
			{
				this.showMessageBoxError = false;
			}
		}
		else{
			toReceiverEmail.reset();
			toReceiverEmail.disable();
			toReceiverClient.reset();
			toReceiverClient.disable();
			toEmailCheckBox.reset();
			toEmailCheckBox.disable();
			this.resetRecipientControl();
			this.showErrorMessage = false;
			this.showEmailErrorMessage = false;
			this.isRecipientCheckedChanged = false;
			if(this.formGroup.get(Constants.NotificationMessageMessagebox).value != null || this.formGroup.get(Constants.NotificationMessageMessagebox).value != "")
			{
				this.showMessageBoxError = false;
			}
		}
		this.validatForm();
	 }

	 onRecipientChanged(event){
		let toReceiverClient =this.formGroup.get(Constants.NotificationToReceiverClient);
		let toReceiverEmail = this.formGroup.get(Constants.NotificationToReceiverEmail);
		this.isRecipientCheckedChanged = event.target.checked;
		if(this.isRecipientCheckedChanged){
			this.showEmailErrorMessage = true;
		}
		else{
			this.showEmailErrorMessage = false;
		}
		if( this.isRecipientCheckedChanged == true && toReceiverClient.value != ""){
			toReceiverEmail.reset();
			toReceiverEmail.enable();
			this.resetRecipientControl();
		}
		else{
			toReceiverEmail.reset();
			toReceiverEmail.disable();
			this.resetRecipientControl();
		}
	}

     ngOnDestroy(): void {
		this._formChangesSubscription.unsubscribe();
		this._formStateService.reset();
	}

	onCancel() {
        this.navigateToNotificationSummary();
    }

	navigate() {
        this._router.navigate(['/', 'admin', 'notifications','compose']);
    }

	navigateToNotificationSummary(){
		this._router.navigate(['/', 'notifications']);
	}

	async getClients() {
		this._loadingService.setLoading(true);
			await this._ClientService.getAllActiveClients(this.applicationAbbreviation).then((result) => {
				this.clients = result;
				this.clientsDataSource = this.getDataSource(this.clients);
				this._loadingService.setLoading(false);
			},
				(error) => {
					this.errorMessages = error.error;
					this._loadingService.setLoading(false);
				});
		}

	setSelectedClientId(clientId: number){
		this.selectedClientId =clientId;
		if(this.selectedClientId != 0 && this.selectedClientId != null)
		{
			this.showErrorMessage = false;
			this.showEmailErrorMessage = false;
			this.formGroup.get(Constants.NotificationToEmailCheckBox).enable();
			if(this.formGroup.get(Constants.NotificationToEmailCheckBox).value == false)
			{
				this.formGroup.get(Constants.NotificationToReceiverEmail).reset();
				this.formGroup.get(Constants.NotificationToReceiverEmail).disable();
			}
			else{
				if(this.formGroup.get(Constants.NotificationToEmailCheckBox).value == true)
				{
					this.formGroup.get(Constants.NotificationToReceiverEmail).reset();
					this.formGroup.get(Constants.NotificationToReceiverEmail).enable();
					this.showEmailErrorMessage = true;
				}
			}
		}
		else{
			this.formGroup.get(Constants.NotificationToEmailCheckBox).reset();
			this.formGroup.get(Constants.NotificationToEmailCheckBox).disable();
			this.formGroup.get(Constants.NotificationToReceiverEmail).reset();
			this.formGroup.get(Constants.NotificationToReceiverEmail).disable();
			this.showErrorMessage = true;
			this.showEmailErrorMessage = false;
			this.isRecipientCheckedChanged =false;
		}
	}

	setShowErrorMessage(multiSelectErrorMessage: boolean){
		this.showEmailErrorMessage = multiSelectErrorMessage;
	}

	resetRecipientControl() {
		this.emails = [];
		this.emailsDataSource = this.getDataSource(this.emails);
    	this.formGroup.get(Constants.NotificationToReceiverEmail).setValue([]);
		this.searchableMultiSelectbox?.multiSelectTagBox?.instance?.option('noDataText', Constants.AutoCompleteSearchDefaultText);
	}

	onRecipientInput(searchValue) {
		if(searchValue?.length >= Constants.MinimunSearchLength) {
			this.searchTerm$.next(searchValue);
			this.searchableMultiSelectbox?.multiSelectTagBox?.instance?.option('noDataText', Constants.NoDataText);
		} else if(!this.formGroup?.get(Constants.NotificationToReceiverEmail)?.value?.value || this.formGroup?.get(Constants.NotificationToReceiverEmail)?.value?.value?.length == 0){
			this.resetRecipientControl();
		}
	}

	onRecipientOutsideClick(event) {
		if(!event?.event?.currentTarget?.className.includes('dx-dropdowneditor-active') && (!this.formGroup?.get(Constants.NotificationToReceiverEmail)?.value?.value || this.formGroup?.get(Constants.NotificationToReceiverEmail)?.value?.value?.length == 0)) {
			this.resetRecipientControl();
		}
	}

	showError(input : string) : boolean{
			return (input == "");
    }

	setShowMessageBoxError(messageBoxError : boolean){
		this.showMessageBoxError = messageBoxError;
	}

	//we need to convert message as we get value within <p> tag
	htmlToPlaintext(text) {
		return text ? String(text).replace(/<[^>]+>/gm, "") : "";
	}

	validatForm(){
		let isNotifiationMessage=false;
		let htmlNotificationMesage = this.formGroup.get(Constants.NotificationMessageMessagebox);
		let notificationMessage=this.htmlToPlaintext(htmlNotificationMesage?.value?.value);
		if(notificationMessage?.trim()==""){
			isNotifiationMessage=true;
			this.showMessageBoxError=true;
		}else{
			this.showMessageBoxError=false;
		}

		let notificationSubject = this.formGroup.get(Constants.NotificationTitle).value?.trim();
		if(notificationSubject?.length==0 || isNotifiationMessage || this.showEmailErrorMessage || this.showMessageBoxError || this.showErrorMessage || this.formGroup.get(Constants.NotificationTitle).errors){
			this.isFormValid=false;
		}
		else{
			this.isFormValid=true;
		}
	}

	trimValue(controlName : string): void {
        var value =  this.formGroup.get(controlName).value.trim();
        this.formGroup.get(controlName).setValue(value);
    }

    async getEmailTemplateBody() {
      this._loadingService.setLoading(true);
      let result = await this._notificationService.getNotificationTemplateByApplicationAbbreviation(this.applicationAbbreviation);
      if (result) {
        this.formGroup.get(Constants.NotificationMessageMessagebox).setValue(result.body);
      }
      this._loadingService.setLoading(false);
    }

    resetEmailTemplateBody(){
      this.formGroup.get(Constants.NotificationMessageMessagebox).setValue('');
    }

	public getDataSource(ds) {
		let dataSource = new DataSource({
		  store: ds,
		  paginate: true,
		  pageSize: 50
		});
  
		return dataSource;
	}

	public openAndCloseDropdownInstance(instance: any) {
		instance?.close();
		setTimeout(() => instance?.open());
	}
}

export enum NotificationType{
	AllUsers = 1,
	Client = 2,
	Email = 3
}
